import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Link, useNavigate } from 'react-router-dom';
import { FaRegUserCircle, FaUserCircle } from "react-icons/fa";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Modal } from 'antd';
import { Nav, Navbar, NavDropdown, Container } from 'react-bootstrap';
import '../App.css'

function AdminNavbar() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElMaster, setAnchorElMaster] = useState(null);
  const [anchorElTransaction, setAnchorElTransaction] = useState(null);
  const [anchorElReport, setAnchorElReport] = useState(null);
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const role = sessionStorage.getItem('role');
  const userName = sessionStorage.getItem('userName');
  const branchName = sessionStorage.getItem('branchName');

//   const settings = [
//   // { label: userName || 'Guest', route: '/' },
//   { label: `Hi, ${userName || 'Guest'}`, route: '/', style: { backgroundColor: 'grey', padding: '5px', borderRadius: '5px', color: 'white' }  },
//   { label: 'Logout', route: '/' },
// ];
// const masterItems = [
//   { label: 'User Master', route: '/m-1' },
//   { label: 'Mine Master', route: '/m-2' },
//   { label: 'Product Master', route: '/m-3' },
//   { label: 'Rate Master', route: '/m-4' },
//   { label: 'Customer Master', route: '/m-5' },
//   { label: 'Employee Master', route: '/m-6' },
// ];

//   // Filter masterItems based on role
//   const filteredMasterItems = masterItems.filter(item => 
//     !(role === 0 && ['User Master', 'Mine Master'].includes(item.label))
//   );

// const transactionItems = [
//   { label: 'Assign Mine To User', route: '/trans-1' },
//   { label: 'Billing Entry', route: '/trans-2' },
//   { label: 'Payment Receive', route: '/trans-3' },
//   { label: 'Expenses Entry', route: '/trans-4' },
//   { label: 'Employee Expense', route: '/trans-5' },
// ];

// // Filter masterItems based on role
// const filteredTransactionItems = transactionItems.filter(item => 
//   !(role === 0 && ['Assign Mine To User'].includes(item.label))
// );

// const reportItems = [
//   { label: 'Billing Summery', route: '/r-1' },
//   { label: 'Receipt Summery', route: '/r-2' },
//   { label: 'Payment Pending Summery', route: '/r-3' },
//   { label: 'Payment Pending Summery', route: '/r-3' },
//   { label: 'Employee Expense Summery', route: '/r-4' },
//   { label: 'Expenses Entry Summery', route: '/r-5' },
// ];

//   const handleOpenNavMenu = (event) => {
//     setAnchorElNav(event.currentTarget);
//   };

//   const handleOpenUserMenu = (event) => {
//     setAnchorElUser(event.currentTarget);
//   };

//   const handleOpenMasterMenu = (event) => {
//     setAnchorElMaster(event.currentTarget);
//   };

//   const handleOpenTransactionMenu = (event) => {
//     setAnchorElTransaction(event.currentTarget);
//   };

//   const handleOpenReportMenu = (event) => {
//     setAnchorElReport(event.currentTarget);
//   };

//   const handleCloseNavMenu = () => {
//     setAnchorElNav(null);
//   };

//   const handleCloseUserMenu = () => {
//     setAnchorElUser(null);
//   };

//   const handleCloseMasterMenu = () => {
//     setAnchorElMaster(null);
//   };

//   const handleCloseTransactionMenu = () => {
//     setAnchorElTransaction(null);
//   };

//   const handleCloseReportMenu = () => {
//     setAnchorElReport(null);
//   };

//   const handleMasterItemClick = (route) => {
//     navigate(route);
//     handleCloseMasterMenu();
//   };

//   const handleTransactionItemClick = (route) => {
//     navigate(route);
//     handleCloseTransactionMenu();
//   };

//   const handleReportItemClick = (route) => {
//     navigate(route);
//     handleCloseReportMenu();
//   };


  const showLogoutModal = () => {
    setIsLogoutModalVisible(true);
  };

  const handleLogout = () => {
    setIsLogoutModalVisible(false);
    sessionStorage.clear(); // Clear session storage
    navigate('/'); // Navigate to the login page
  };

  const handleCancelLogout = () => {
    setIsLogoutModalVisible(false);
  };
//====================================================

const navbg = {
  // background: "#2E86C1",
  // background: "-webkit-linear-gradient(to right,rgb(0, 0, 0),rgb(3, 47, 90))",
  // background: "linear-gradient(to right, rgb(0, 0, 0),rgb(3, 47, 90))",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
}

//====================================================

  return (
    // <AppBar position="static" style={{ backgroundColor: "#001F3F", }}>
    //   <div className='container-fluid '>
    //     <Toolbar disableGutters>
          
    //       <Typography
    //         variant="h6"
    //         sx={{
    //           mr: 2,
    //           display: { xs: 'none', md: 'flex' },
    //           fontWeight: 800,
    //           letterSpacing: '.2rem',
    //           color: 'inherit',
    //           textDecoration: 'none',
    //         }}
    //       >
    //          RockLedger ({branchName})
    //       </Typography>

    //       <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
    //         <IconButton
    //           size="large"
    //           aria-label="menu"
    //           aria-controls="menu-appbar"
    //           aria-haspopup="true"
    //           onClick={handleOpenNavMenu}
    //           color="inherit"
    //         >
    //           <MenuIcon />
    //         </IconButton>
    //         <Menu
    //           anchorEl={anchorElNav}
    //           open={Boolean(anchorElNav)}
    //           onClose={handleCloseNavMenu}
    //         >
    //          <MenuItem onClick={() => navigate('/dashboard')}>
    //             <Typography sx={{ textAlign: 'center' }}>Dashboard</Typography>
    //           </MenuItem>
    //           <MenuItem onClick={handleOpenMasterMenu}>
    //             <Typography sx={{ textAlign: 'center' }}>Masters</Typography>
    //           </MenuItem>
    //           <MenuItem onClick={handleOpenTransactionMenu}>
    //             <Typography sx={{ textAlign: 'center' }}>Transactions</Typography>
    //           </MenuItem>             
    //           <MenuItem onClick={handleOpenReportMenu}>
    //             <Typography sx={{ textAlign: 'center' }}>Reports</Typography>
    //           </MenuItem>
    //         </Menu>
    //       </Box>

          
    //       <Typography
    //         variant="h5"
    //         noWrap
    //         sx={{
    //           mr: 2,
    //           display: { xs: 'flex', md: 'none' },
    //           flexGrow: 1,
    //           fontWeight: 700,
    //           letterSpacing: '.3rem',
    //           color: 'inherit',
    //           textDecoration: 'none',
    //         }}
    //       >
    //           RockLedger <br/> ({branchName})
    //       </Typography>

    //       <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} style={{justifyContent:"end",padding:"0px 20px 0px 0px"}}>
    //         <Button className='hoverEffect' sx={{ my: 2, color: 'white', display: 'block' }} onClick={() => navigate('/dashboard')}>Dashboard</Button>
    //         <Button className='hoverEffect'
    //           sx={{ my: 2, color: 'white', display: 'block' }}
    //           onClick={handleOpenMasterMenu}
    //         >
    //           Masters
    //         </Button>
    //         <Menu 
    //           anchorEl={anchorElMaster}
    //           open={Boolean(anchorElMaster)}
    //           onClose={handleCloseMasterMenu}
    //           anchorOrigin={{
    //             vertical: 'bottom',
    //             horizontal: 'left',
    //           }}
    //           transformOrigin={{
    //             vertical: 'top',
    //             horizontal: 'left',
    //           }}
    //         >
    //           {filteredMasterItems.map((item) => (
    //             <MenuItem
    //               key={item.label}
    //               onClick={() => handleMasterItemClick(item.route)}
    //             >
    //               {item.label}
    //             </MenuItem>
    //           ))}
    //         </Menu>

    //         <Button className='hoverEffect'
    //           sx={{ my: 2, color: 'white', display: 'block' }}
    //           onClick={handleOpenTransactionMenu}
    //         >
    //           Transactions
    //         </Button>
    //         <Menu
    //           anchorEl={anchorElTransaction}
    //           open={Boolean(anchorElTransaction)}
    //           onClose={handleCloseTransactionMenu}
    //           anchorOrigin={{
    //             vertical: 'bottom',
    //             horizontal: 'left',
    //           }}
    //           transformOrigin={{
    //             vertical: 'top',
    //             horizontal: 'left',
    //           }}
    //         >
    //           {filteredTransactionItems.map((item) => (
    //             <MenuItem
    //               key={item.label}
    //               onClick={() => handleTransactionItemClick(item.route)}
    //             >
    //               {item.label}
    //             </MenuItem>
    //           ))}
    //         </Menu>          
  
    //         <Button className='hoverEffect'
    //           sx={{ my: 2, color: 'white', display: 'block' }}
    //           onClick={handleOpenReportMenu}
    //         >
    //           Report
    //         </Button>
    //         <Menu
    //           anchorEl={anchorElReport}
    //           open={Boolean(anchorElReport)}
    //           onClose={handleCloseReportMenu}
    //           anchorOrigin={{
    //             vertical: 'bottom',
    //             horizontal: 'left',
    //           }}
    //           transformOrigin={{
    //             vertical: 'top',
    //             horizontal: 'left',
    //           }}
    //         >
    //           {reportItems.map((item) => (
    //             <MenuItem
    //               key={item.label}
    //               onClick={() => handleReportItemClick(item.route)}
    //             >
    //               {item.label}
    //             </MenuItem>
    //           ))}
    //         </Menu>
    //      </Box>

    //       <Box sx={{ flexGrow: 0 }}>
    //         <Tooltip title="">
    //           <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>                
    //             <FaRegUserCircle style={{color:"#8ec7ed",fontSize:"30px"}} />
    //           </IconButton>
    //         </Tooltip>
    //         <Menu
    //           sx={{ mt: '45px' }}
    //           id="menu-appbar"
    //           anchorEl={anchorElUser}
    //           anchorOrigin={{
    //             vertical: 'top',
    //             horizontal: 'right',
    //           }}
    //           keepMounted
    //           transformOrigin={{
    //             vertical: 'top',
    //             horizontal: 'right',
    //           }}
    //           open={Boolean(anchorElUser)}
    //           onClose={handleCloseUserMenu}
    //         >
    //           {settings.map((setting) => (
    //             <MenuItem 
    //               key={setting.label} 
    //               onClick={setting.label === 'Logout' ? showLogoutModal : handleCloseUserMenu}
    //             >
    //               <Typography sx={{ textAlign: 'center' }}>{setting.label}</Typography>
    //             </MenuItem>
    //           ))}
    //         </Menu>
    //       </Box>
    //     </Toolbar>

    //     <footer className='fixed-bottom'>
    //     <Typography variant="body2" className='py-1' style={{ backgroundColor: "rgb(0, 31, 63)" }} align="center">
    //       {'Developed by TechnoAarv Solution'}
    //       {/* <Link color="inherit" href="https://www.your-site.com">
    //         {'Your Site'}
    //       </Link> */}
    //     </Typography>
    //     </footer>
    //   </div>

    //   {/* Logout Confirmation Modal */}
    //   <Modal
    //     title="Logout Confirmation"
    //     visible={isLogoutModalVisible}
    //     onOk={handleLogout}
    //     onCancel={handleCancelLogout}
    //     okText="Yes, Logout"
    //     cancelText="Cancel"
    //   >
    //     <Typography>Are you sure you want to logout?</Typography>
    //   </Modal>

    // </AppBar>

    <Navbar className='row m-0' collapseOnSelect expand="lg" variant="dark" style={{backgroundColor:"black"}}>
    <Container className='col-12' style={{}}>
      {/* <Navbar.Brand><img src={logo} alt="" width="200px" /></Navbar.Brand> */}
      <Navbar.Brand  style={{color:"#f79400",fontWeight:"bolder",display:"flex",justifyContent:"space-between",width:"55%",}}>  RockLedger &nbsp;&nbsp; <span style={{color:"#fff"}}>&nbsp;{branchName}&nbsp;</span> </Navbar.Brand>
      {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ color: "#fff", }} >
        <MenuIcon fontSize='medium' />
      </Navbar.Toggle> */}
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ms-auto"></Nav>
        {/* <Nav>
          <Nav.Link className='navtxt' href="#/dashboard">Dashboard</Nav.Link>

          <NavDropdown className='navtxt1' title={<span className='navtxt'>Masters</span>} id="basic-nav-dropdown"> 
          {role==1 && ( 
              <>
              <NavDropdown.Item className='navText1' href="#/m-1">User Master</NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/m-2">Mine Master</NavDropdown.Item>
              </>
            )}           
            
            <NavDropdown.Item className='navText1' href="#/m-3">Product Master</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/m-4">Rate Master</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/m-5">Customer Master</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/m-6">Employee Master</NavDropdown.Item>
          </NavDropdown>

          <NavDropdown className='navtxt1' title={<span className='navtxt'>Transactions</span>} id="basic-nav-dropdown">            
            {role==1 && ( 
              <>
              <NavDropdown.Item className='navText1' href="#/trans-1">Assign Mine To User</NavDropdown.Item>
              </>
            )}
              <NavDropdown.Item className='navText1' href="#/trans-2">Billing Entry</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/trans-3">Payment Receive</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/trans-4">Expenses Entry</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/trans-5">Employee Expense</NavDropdown.Item>
            <NavDropdown.Item className='navText1' href="#/trans-6">Opening Balance Entry</NavDropdown.Item>
          </NavDropdown> */}

          {/* <NavDropdown className='navtxt1' style={{marginRight:"60px",}} title={<span className='navtxt'>Reports</span>} id="basic-nav-dropdown">            
          <div className='p-0' style={{flexWrap:"nowrap",fontSize:"14px"}}>
                <NavDropdown.Item className='navText1' href="#/r-1">Billing Summery</NavDropdown.Item>
                <NavDropdown.Item className='navText1' href="#/r-2">Receipt Summery</NavDropdown.Item>
                <NavDropdown.Item className='navText1' href="#/r-3">Payment Pending Summery</NavDropdown.Item>
                <NavDropdown.Item className='navText1' href="#/r-4">Employee Expense Summery</NavDropdown.Item>
                <NavDropdown.Item className='navText1' href="#/r-5">Expenses Entry Summery</NavDropdown.Item>
                <NavDropdown.Item className='navText1' href="#/r-7">Finanacial Outcome Summery</NavDropdown.Item>
                {/* <NavDropdown.Item className='navText1' href="#/r-6">Payment Recieve Summery</NavDropdown.Item> 
          </div>
          </NavDropdown> */}

          {/* <Nav.Link className='navtxt' href='#/mde001/' >Muhurta Data Entry</Nav.Link> */}

          {/* <Nav.Link className='navtxt fw-bolder'  onClick={() => showLogoutModal()}>Logout <ExitToAppIcon fontSize='small' /></Nav.Link> */}

          {/* <NavDropdown
           className='navtxt1'
             title={ <span className='navtxt' >  <FaUserCircle size={18} style={{marginRight: "8px" }}/>{userName}</span>}
           id="user-nav-dropdown"
         style={{ marginRight: "60px"}}
            >
            
              <NavDropdown.Item  className='navText1' onClick={showLogoutModal}>
                Logout <ExitToAppIcon fontSize="small" style={{ marginLeft: "5px" }} />
              </NavDropdown.Item>
              <NavDropdown.Item className='navText1' href="#/pass">Change Password</NavDropdown.Item>
            </NavDropdown>
          
        </Nav> */}
      </Navbar.Collapse>
    </Container>

      {/* Logout Confirmation Modal */}
      {/* <Modal
        title="Logout Confirmation"
         visible={isLogoutModalVisible}
       onOk={handleLogout}
         onCancel={handleCancelLogout}
         okText="Yes, Logout"
       cancelText="Cancel"
      >
        <Typography>Are you sure you want to logout?</Typography>
     </Modal> */}

  </Navbar>

  );
}

export default AdminNavbar;
